module.exports = __webpack_public_path__ + "img/selected0-min.9cf8d280.png";